import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

// SERVICE
import { pCtContractSupervisorUpdate } from "../../../service/400/P415Service";

export default function P415({ dialog, setDialog, onGetpCtContractInfo }) {
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ contractNo: "", supervisorName: "", supervisorEmployeeId: "" });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // DropDown

    useEffect(() => {
        if (dialog.dialog_415.open === true) {
            setformObject({ ...formObject, ...dialog.dialog_415.dataSet, userId: dialog.dialog_415.userId, contractNo: dialog.dialog_415.contractNo });
        }
    }, []);

    const setViewForm = (key) => {
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setformObject({ ...formObject, [key]: val });
    };

    const validation = (object, act) => {
        if (act === "D") {
            return true;
        } else {
            if (object.supervisorName === "" || object.supervisorEmployeeId === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
    };
    const handlerCloseDialog = () => {
        setDialog({ ...dialog, dialog_415: { open: false, action: "", dataSet: null } });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };
    const submitForm = (act) => {
        if (validation(formObject, act)) {
            const req = {
                actionCode: act,
                contractNo: setViewForm("contractNo"),
                supervisorEmployeeId: setViewForm("supervisorEmployeeId"),
                supervisorName: setViewForm("supervisorName"),
                userId: setViewForm("userId"),
            };
            pCtContractSupervisorUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
            onGetpCtContractInfo();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dialog.dialog_415.action === "EDIT" ? "U" : "A")} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-ban" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
                <Button label="ลบรายการ" icon="pi pi-trash" onClick={() => setDeleteDialog({ open: true })} className="p-button-danger p-button" disabled={dialog.dialog_415.action === "EDIT" ? false : true} />
            </div>
        );
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <Dialog header="รายชื่อผู้ควบคุมงาน" visible={dialog.dialog_415.open} style={{ width: "55vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>เลขที่สัญญา</label>
                        <InputText value={setViewForm("contractNo")} maxLength={20} disabled={true} />
                    </div>
                    <div className="p-col-6">
                        <label>
                            ชื่อ–นามสกุล<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ ชื่อ–นามสกุล" className={submitted && !formObject.supervisorName ? "p-invalid" : ""} value={setViewForm("supervisorName")} onChange={(e) => setValueForm("supervisorName", e.target.value)} maxLength={200} />
                        {submitted && !formObject.supervisorName && validateInputText("supervisorName", "ชื่อ–นามสกุล")}
                    </div>
                    <div className="p-col-6">
                        <label>
                            รหัสพนักงาน<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ รหัสพนักงาน" className={submitted && !formObject.supervisorEmployeeId ? "p-invalid" : ""} value={setViewForm("supervisorEmployeeId")} onChange={(e) => setValueForm("supervisorEmployeeId", e.target.value)} maxLength={20} />
                        {submitted && !formObject.supervisorEmployeeId && validateInputText("committeeEmployeeId", "รหัสพนักงาน")}
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
